/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import type { TablePaginationConfig, TableProps } from "antd"
import { Table, Typography } from "antd"
import type React from "react"

const { Text } = Typography
import { useTableScroll } from "@/hooks/useTableScroll"
import "@/styles/table.full.css"

interface IdiomTableProps {
  data: any[]
  loading: boolean
  selectedRowKeys: React.Key[]
  onSelectionChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => void
  pagination?: TableProps["pagination"]
}

const IdiomTable: React.FC<IdiomTableProps> = ({ data, loading, selectedRowKeys, onSelectionChange, pagination }) => {
  const { scrollConfig, tableWrapperRef } = useTableScroll()

  const columns: TableProps["columns"] = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 80,
      align: "center",
      render: (value: number) => <span className="font-semibold">{value}</span>,
    },
    {
      title: "Thành ngữ",
      dataIndex: "phrase",
      key: "phrase",
      width: 250,
      render: (value: string) => <span className="font-bold text-primary">{value}</span>,
    },
    {
      title: "Ý nghĩa & Định nghĩa",
      key: "meaning_definition",
      render: (_: any, record: any) => {
        if (!record.meaning && !record.definition) return <Text type="secondary">—</Text>
        return (
          <div className="text-xs">
            {record.meaning && (
              <div>
                <Text strong>{record.meaning}</Text>
              </div>
            )}
            {record.definition && (
              <div className="mt-1">
                <Text type="secondary" italic>
                  {record.definition}
                </Text>
              </div>
            )}
          </div>
        )
      },
    },
  ]

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectionChange,
  }

  return (
    <div className="min-h-0 min-w-0 flex-1" ref={tableWrapperRef}>
      <Table
        bordered
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        rowSelection={rowSelection}
        pagination={pagination as TablePaginationConfig}
        scroll={{ x: "100%", y: scrollConfig.y }}
        size="small"
        classNames={{
          root: "full-height-table",
        }}
      />
    </div>
  )
}

IdiomTable.displayName = "IdiomTable"

export default IdiomTable
